import { EventListItem, ResourceSectionCard, Stack } from '@all-manager/design-system-v2';
import { useUpcomingEventsSection } from './useUpcomingEventsSection';

export default function UpcomingEventsSection() {
  const hook = useUpcomingEventsSection();

  return (
    <ResourceSectionCard
      variant="rendezVous"
      title="Évènements à venir"
      count={hook.items.length}
      isLoading={hook.isLoading}
      isEmpty={hook.items.length === 0}
      emptyLabel="Aucun évènement à venir"
    >
      <Stack spacing={0.5}>
        {hook.items.map((event) => {
          const subtitle = [event.sub_topics?.name, event.provider_name]
            .filter(Boolean)
            .join(' · ');

          return (
            <EventListItem
              key={event.id}
              title={event.title}
              date={event.date}
              end_date={event.end_date}
              all_day={event.all_day}
              subtitle={subtitle || undefined}
              provider_name={event.provider_name}
              onClick={
                event.sub_topics?.id
                  ? () => hook.handleEventClick(event.sub_topics.id)
                  : undefined
              }
            />
          );
        })}
      </Stack>
    </ResourceSectionCard>
  );
}

export { UpcomingEventsSection };

